import { useState } from 'react';
import { Loader2, Truck, X } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

export const BulkSupplierBar = ({ selectedIds, suppliers, onClear, onDone }) => {
  const [supplier, setSupplier] = useState('');
  const [busy, setBusy] = useState(false);
  const count = selectedIds.length;
  if (!count) return null;

  const assign = async () => {
    const name = supplier.trim();
    if (!name) return toast.error('Pick or type a supplier');
    setBusy(true);
    try {
      const { data } = await api.post('/admin/products/bulk-supplier', { product_ids: selectedIds, supplier: name });
      toast.success(`${data.matched} product${data.matched === 1 ? '' : 's'} assigned to ${data.supplier}`);
      setSupplier('');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Assign failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="sticky top-2 z-20 mb-4 border border-neutral-900 bg-white shadow-sm p-3 flex flex-wrap items-center gap-2" data-testid="bulk-supplier-bar">
      <span className="sans text-xs tracking-widest uppercase" data-testid="bulk-supplier-count">{count} selected</span>
      <input
        list="bulk-supplier-options"
        value={supplier}
        onChange={(e) => setSupplier(e.target.value)}
        placeholder="Supplier name"
        className="ije-input h-10 flex-1 min-w-[160px] md:max-w-xs"
        data-testid="bulk-supplier-input"
      />
      <datalist id="bulk-supplier-options">
        {suppliers.map((s) => <option key={s.name} value={s.name} />)}
      </datalist>
      <button type="button" onClick={assign} disabled={busy} className="btn-primary h-10" data-testid="bulk-supplier-apply">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Truck size={14} />} Assign supplier
      </button>
      <button type="button" onClick={onClear} className="sans text-xs uppercase tracking-widest text-neutral-500 hover:text-black inline-flex items-center gap-1" data-testid="bulk-supplier-clear">
        <X size={14} /> Clear
      </button>
    </div>
  );
};
